import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgAbout from '../../../../assets/img/Langding/BgAbout.png'

export const Contaner = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #20665E;
  position: relative;
  flex-direction: column;
  padding: 50px 4vw 6vw;
  background-image: url('${BgAbout}');
  height: 1100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  img{
    margin-bottom: 60px;
    opacity: 0.6;
  }
  :after {
    width: 100%;
    height: 100px;
    position: absolute;
    content: "";
    top: 0px;
    left: 0px;
    transform: translateY(-100%);
    background: linear-gradient(180deg, rgba(11, 27, 41, 0) 0%, #20665E 60.62%);
  }
  h1 {
    font-weight: 700;
    font-size: 50px;
    line-height: 110%;
    font-family: PoppinsBold;
    margin-bottom: 45px;
  }
  p {
    font-weight: 500;
    font-size: 24px;
    line-height: 110%;
    text-align: center;
    width: 100%;
    max-width: 1162px;
    margin-bottom: 30px;
  }
  @media only screen and (max-width: 768px){
    height: 115vw;
    h1{
      font-size: 3.73vw;
    }
    p{
      font-size: 3.27vw;
    }
  }
  @media only screen and (max-width: 430px){
    height: 486px;
    h1{
      font-size: 16px;
    }
    p{
      font-size: 12px;
      margin-bottom: 16px;
    }
  }
`;
